<header>
  <div class="d-flex justify-content-end">
    <div class="icons-container">
      <i class="fa-solid fa-arrow-right-from-bracket" (click)="logout()" style="cursor: pointer"></i>
    </div>
  </div>
</header>
